module.exports = __webpack_public_path__ + "static/media/features-highimpact-full.859e4e7f.png";